module.exports = __webpack_public_path__ + "static/img/63.a87684b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/63.png
// module id = BQbb
// module chunks = 0